import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { IIdItem } from '../../../spacesPlatform/models/resourceParts';

export interface ISetDatasourceRefreshModeParams extends IIdItem {
  refreshMode: string;
}

export class SetDatasourceRefreshModeRequest extends Request<ISetDatasourceRefreshModeParams, IEmptyResult> {
  constructor(params: ISetDatasourceRefreshModeParams) {
    super('setDatasourceRefreshMode', params);
  }
}
